import { jsx as _jsx } from "react/jsx-runtime";
import { Parent } from '..';
const Checkbox = ({ name, className, value, id, type, onChange, checked, disabled }) => {
    return (_jsx(Parent, { className: "", children: _jsx("input", { type: type, name: name, value: value, id: id, className: className, onChange: onChange, checked: checked, disabled: disabled }) }));
};
export default Checkbox;
